import { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import type { Flow } from '../features/auth/authSlice';

interface ProtectedRouteProps {
  /** Restrict to a specific flow; omit to allow any authenticated user. */
  flow?: Flow;
  children: ReactElement;
}

/** Gate a route behind authentication (and optionally a specific flow). */
export default function ProtectedRoute({ flow, children }: ProtectedRouteProps) {
  const user = useAppSelector((s) => s.auth.user);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (flow && user.flow !== flow) {
    // Signed in under a different flow — send to their own home.
    return <Navigate to={user.flow === 'admin' ? '/admin' : '/user'} replace />;
  }
  return children;
}
